import { Mask } from './Mask'

export type { MaskProps } from './Mask'

export default Mask